import { Model } from 'pinia-orm';
import Application from './Application';
import User from './User';
import TimelineEvent from './TimelineEvent';
import moment from 'moment';
import Document from './Document';
import InterviewInvitation from "./InterviewInvitation";

export default class Invitation extends Model {

    static get entity () {
        return 'invitations';
    }

    static fields () {
        return {
            id: this.uid(),
            application_id: this.attr(null),
            user_id: this.attr(null),
            from: this.attr(''),
            to: this.attr(''),
            bcc: this.attr([]),
            subject: this.attr(''),
            message: this.attr(''),
            sent: this.attr(null),
            failed: this.attr(null),
            failed_reason: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            application: this.belongsTo(Application, 'application_id'),
            user: this.belongsTo(User, 'user_id'),
            documents: this.morphMany(Document, 'attachable_id', 'attachable_type'),
            timeline_event: this.morphOne(TimelineEvent, 'eventable_id', 'eventable_type'),
            interviewInvitation: this.hasOne(InterviewInvitation, 'outbound_email_id')
        }
    }

    get moment () {
        return this.sent ? moment(this.sent) : null;
    }
}
